
// footer.js
const termsLink = process.env.PARCEL_TERMS || "/termsandconditions/index.html";
const privacyLink = process.env.PARCEL_PRIVACY || "/privacypolicy/index.html";
const refundLink = process.env.PARCEL_REFUND || "/refundpolicy/index.html";
const cocLink = process.env.PARCEL_COC || "/codeofconduct/index.html";

function updateFooterLinks() {
  const links = document.querySelectorAll(".footer-link");
  if (links.length === 0) {
    return setTimeout(updateFooterLinks, 50);
  }

  links.forEach(link => {
    const text = link.textContent.trim().toLowerCase();

    if (text.includes("code of conduct")) link.href = cocLink;
    else if (text.includes("refund")) link.href = refundLink;
    else if (text.includes("privacy")) link.href = privacyLink;
    else if (text.includes("terms")) link.href = termsLink;
  });
}

updateFooterLinks();